<nav class="navbar navbar-expand-md navbar-dark background-primary">
  <div class="container">
    <div class="w-100 d-flex justify-content-center">
      <a href="https://www.cps.edu/" class="p-1" target="_blank">
        <img src="assets/images/cpslogo.png" width="230px" alt="CPS Logo">
      </a>
    </div>
  </div>
</nav>
